module.exports = __webpack_public_path__ + "media/icons/smartsearch/materials/wg-c3f7866ebfd3130e439aaed1302decde.png";